import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Ajutor() {
  const [intrebareDeschiса, setIntrebareDeschisa] = useState(null);

  const intrebari = [
    {
      intrebare: 'Cum public un anunt?',
      raspuns: 'Apasa butonul "+ Adauga Anunt" din bara de navigare, completeaza formularul cu titlul, categoria, pretul, descrierea si imaginile produsului, apoi apasa "Publica anuntul". Anuntul va fi verificat de administrator inainte de a fi vizibil public.'
    },
    {
      intrebare: 'Cat costa publicarea unui anunt?',
      raspuns: 'Publicarea anunturilor pe Tranzitio este complet gratuita. Nu exista comisioane sau taxe ascunse.'
    },
    {
      intrebare: 'De ce anuntul meu nu apare pe site?',
      raspuns: 'Fiecare anunt este verificat de administratorul platformei inainte de publicare. Acest proces dureaza de obicei cateva ore. Poti vedea statusul anuntului tau in sectiunea "Anunturile mele" din contul tau.'
    },
    {
      intrebare: 'Cum pot contacta un vanzator?',
      raspuns: 'Pe pagina anuntului gasesti butonul "Mesaj" care iti permite sa trimiti un mesaj direct vanzatorului prin sistemul nostru de mesagerie. Poti de asemenea apasa butonul "Telefon" pentru a vedea numarul de contact.'
    },
    {
      intrebare: 'Cum sterg un anunt?',
      raspuns: 'Mergi la sectiunea "Anunturile mele" din contul tau, gaseste anuntul pe care vrei sa il stergi si apasa butonul "Sterge". Actiunea este ireversibila.'
    },
    {
      intrebare: 'Cum imi schimb parola?',
      raspuns: 'Mergi la "Detaliile mele" din meniul contului, deruleaza pana la sectiunea "Securitate Parola", introdu parola actuala si noua parola, apoi apasa "Salveaza modificarile".'
    }
  ];

  function toggleIntrebare(index) {
    if (intrebareDeschiса === index) {
      setIntrebareDeschisa(null);
    } else {
      setIntrebareDeschisa(index);
    }
  }

  return (
    <div className="min-h-screen bg-[#f8fafc] py-12">
      <div className="max-w-3xl mx-auto px-4">

        <div className="mb-10 text-center">
          <h1 className="text-4xl font-black text-gray-900 mb-3">Ajutor & Contact</h1>
          <p className="text-gray-500 font-medium text-lg">Gaseste raspunsuri la cele mai frecvente intrebari sau contacteaza-ne direct.</p>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 mb-8">
          <h2 className="text-xl font-bold text-gray-900 mb-6">Intrebari frecvente</h2>
          <div className="flex flex-col gap-3">
            {intrebari.map(function(item, index) {
              return (
                <div key={index} className="border border-gray-100 rounded-xl overflow-hidden">
                  <button
                    onClick={function() { toggleIntrebare(index); }}
                    className="w-full flex justify-between items-center px-5 py-4 text-left font-bold text-gray-800 hover:bg-gray-50 transition"
                  >
                    <span>{item.intrebare}</span>
                    <svg
                      className={'w-5 h-5 text-gray-400 transition-transform ' + (intrebareDeschiса === index ? 'rotate-180' : '')}
                      fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {intrebareDeschiса === index && (
                    <div className="px-5 pb-4 text-gray-600 leading-relaxed border-t border-gray-100 pt-3">
                      {item.raspuns}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <h2 className="text-xl font-bold text-gray-900 mb-6">Contacteaza-ne</h2>
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center shrink-0">
                <svg className="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <p className="text-sm font-bold text-gray-500">Email suport</p>
                <p className="font-bold text-gray-900">suport@tranzitio.ro</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center shrink-0">
                <svg className="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <p className="text-sm font-bold text-gray-500">Program raspuns</p>
                <p className="font-bold text-gray-900">Luni - Vineri, 09:00 - 18:00</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-xl">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center shrink-0">
                <svg className="w-5 h-5 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <div>
                <p className="text-sm font-bold text-gray-500">Locatie</p>
                <p className="font-bold text-gray-900">Ploiesti, judetul Prahova</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Ajutor;